var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgApollo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 64,
    viewBox: "0 0 64 64",
    width: 64,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m54.0971 54.0971c-12.2039 12.2039-31.9903 12.2039-44.19419 0-12.20388-12.2039-12.20388-31.9903 0-44.19419 12.20389-12.20388 31.99029-12.20388 44.19419 0 12.2039 12.20389 12.2039 31.99029 0 44.19419z",
    fill: "#00dc55"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m39.9829 38.9156c-2.85-1.3879-5.5377-3.2202-7.9589-5.4968l-21.4245 21.3812c-.2366-.222-.4706-.4484-.70178-.6792-.23122-.2307-.45807-.4642-.68054-.7003l21.42462-21.3812c-2.2815-2.4165-4.1176-5.099-5.5084-7.9436l-24.253352 10.9467c-.066497-.6929-.109846-1.3876-.130048-2.0829l23.58-10.6428c-2.654-6.391-3.1558-13.4623-1.5054-20.11055.7203-.22025 1.4471-.41397 2.1787-.58115-1.8729 6.52705-1.5032 13.5597 1.1092 19.8871l27.2332-12.29166c.265.24687.5267.49919.785.75696.2583.2578.5112.519.7586.7835l-12.3175 27.1776c6.3405 2.6074 13.3877 2.9765 19.9282 1.1072-.1675.7301-.3616 1.4554-.5823 2.1743-6.662 1.6472-13.7479 1.1463-20.1521-1.5026l-10.6655 23.5326c-.6967-.0202-1.3928-.0635-2.0871-.1299zm-13.0671-15.6244 22.8063-10.2936-17.6974 17.6616c-2.1107-2.2444-3.8137-4.7316-5.1089-7.368zm24.1885-8.914-17.6973 17.6615c2.2486 2.1062 4.7407 3.8056 7.3821 5.0981z",
    fill: "#1d3301",
    fillRule: "evenodd"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgApollo);
export default __webpack_public_path__ + "static/media/apollo.f9d7f4e081774d351b944130b3f1b0af.svg";
export { ForwardRef as ReactComponent };